<script setup lang="ts">
import { Button } from '~ds/components/ui/button';
import { Text } from '~ds/components/ui/typography';

import { useSignupLink } from '~/composables/unified/useSignupLink';
import { ENTRY_CTA, ENTRY_SOURCE } from '~/utils/unified/entryTracking';

const { t } = useI18n();
const { isAus } = useClusterCountryConfig();

const { buildLink } = useSignupLink();
const loginLink = computed(() => buildLink({ entrySource: ENTRY_SOURCE.ROOT_UNIFIED, entryCta: ENTRY_CTA.FIND_A_FUTURE }));
</script>

<template>
  <div class="@container">
    <!-- Text -->
    <div class="flex flex-col gap-4 md:flex-row  md:items-center">
      <div class="flex-1">
        <h2 class="text-center md:text-left mx-auto md:mx-0 lg:text-left text-[clamp(3rem,6cqw,5rem)] leading-none tracking-tight font-semibold max-w-[15ch]">
          {{ t('unified.landing.careers.findAFuture') }}
        </h2>
        <Button
          size="lg"
          class="mt-8 hidden md:inline-flex"
          as-child
        >
          <NuxtLink :to="loginLink">
            {{ t('unified.landing.careers.letsGo') }}
          </NuxtLink>
        </Button>
      </div>

      <!-- Fact card -->
      <div class="mt-4 md:mt-0 md:max-w-[45cqw]  lg:mx-0">
        <KUICoreCardBackground
          background-image="/images/kui/unified/graduates.webp"
          sizes="100vw md:40vw"
          :has-border="false"
          :has-padding="false"
        >
          <template #content>
            <div class="flex items-end min-h-80 px-6 py-4 bg-gradient-to-t from-black/60 to-transparent">
              <div>
                <div v-if="isAus" class="mb-5">
                  <Text size="sm" class="text-muted-foreground   mt-24 lg:mt-48">
                    {{ t('unified.landing.careers.source') }} <a
                      href="https://universitiesaustralia.edu.au/media-item/a-degree-of-impact-new-income-data-tells-a-story-of-the-value-of-a-university-education/"
                      class="underline"
                      target="_blank"
                    > {{ t('unified.landing.careers.universitiesAustralia') }}</a>
                  </Text>
                </div>
                <KUICoreTextHighlight
                  class="font-medium tracking-tight leading-none mb-2"
                  background="bg-brand-pink"
                  font-size="4xl"
                >
                  <template #text>
                    {{ t('unified.landing.careers.graduatesFact') }}
                  </template>
                </KUICoreTextHighlight>
              </div>
            </div>
          </template>
        </KUICoreCardBackground>
      </div>
      <div class="mt-8 text-center md:hidden">
        <Button
          size="lg"
          variant="secondary"
          as-child
        >
          <NuxtLink :to="loginLink">
            {{ t('unified.landing.careers.letsGo') }}
          </NuxtLink>
        </Button>
      </div>
    </div>
  </div>
</template>
